import { isMobile } from "components/utility/page-responsive/PageResponsive";
import {
	observeIndividualSiteAnimations,
	disconnectIndividualSiteObserver
} from "utils/individual-site-animations/individualSiteIntersectionObserver";
import { onElementReady } from "utils/onElementReady";

const triggerIndividualSiteAnimations = () => {
	const setAnimationsStatic = () => {
		const animatedMarketsEls = document.querySelectorAll(".animated-markets");
		if (animatedMarketsEls.length) {
			animatedMarketsEls.forEach((el) => {
				el.classList.remove("animate");
				el.classList.add("static");
			});
		}
		const animatedFastFactsEls = document.querySelectorAll(".animated-fast-facts-section");
		if (animatedFastFactsEls.length) {
			animatedFastFactsEls.forEach((el) => {
				el.classList.add("static");
				const facts = el.querySelectorAll(".animated-fast-facts-fact");
				const factsText = el.querySelectorAll(".animated-fast-facts-fact-text");
				facts.forEach((fact, i) => fact.classList.remove(`ff-animate-${i + 1}`, `fact-${i + 1}`));
				factsText.forEach((factText, i) => factText.classList.remove(`ff-animate-${i + 1}`));
			});
		}
	};

	window.addEventListener("resize", () => {
		// nav bar on ios causes resize event to trigger on scroll,
		// this check prevents functions from running if there was NOT a size change
		if (window.innerWidth !== window._WINDOW_WIDTH_IOS) {
			window._WINDOW_WIDTH_IOS = window.innerWidth;
			setAnimationsStatic();
			disconnectIndividualSiteObserver();
		}
	});

	if (!isMobile()) {
		// => 767
		const animatedMarkets = onElementReady(".animated-markets");
		const animatedFastFacts = onElementReady(".animated-fast-facts-section");
		Promise.any([animatedMarkets, animatedFastFacts]).then(() => observeIndividualSiteAnimations());
	}
	if (isMobile()) {
		disconnectIndividualSiteObserver();
	}
};

export default triggerIndividualSiteAnimations;
